import SessionRow from '../SessionRow/SessionRow'
import s from './styles/Timeline.module.scss'

const Timeline = ({
	sessions,
	onResourceClick,
	onAssignmentClick,
	onMarkComplete,
}) => {
	if (!sessions?.length) {
		return <p className={s.empty}>No sessions available for this grade.</p>
	}

	return (
		<div className={s.wrap}>
			<div className={s.list}>
				{sessions.map((session, index) => (
					<SessionRow
						key={session.id}
						session={session}
						isLast={index === sessions.length - 1}
						onResourceClick={onResourceClick}
						onAssignmentClick={onAssignmentClick}
						onMarkComplete={onMarkComplete}
					/>
				))}
			</div>
		</div>
	)
}

export default Timeline
